
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from "react-router";
import { findFilePDF } from '../Facturas/Fetch/FindFacturas';
import { LoginCheck } from "../Facturas/Fetch/Login";
export default function FacturaView() {

    const { uuid } = useParams();
    const [base64data, setBase64data] = useState({show : false, data:''})
    let navigate = useNavigate();

    useEffect(() => {

        if (localStorage.getItem("ContaKMP")) {

            LoginCheck(localStorage.getItem("ContaKMP")).then(res => {

                if (res === '') {
                    localStorage.removeItem("ContaKMP");
                    navigate("/");
                } else {
                    localStorage.setItem("ContaKMP", res);
                    findFilePDF(uuid).then(res => {
                        setBase64data(v => ({...v,
                            show:true,
                            data:res[0].pdf
                    }));
                    })
                }

            }).catch(e => {
                console.log(e)
            })
        } else {
            console.log('nada');
            navigate("/");
        }
    }, [navigate, uuid])

    useEffect(() => {
    }, [uuid])

    return (
        base64data.show === false ?
        <div>Cargando...</div>
        :
        <div className={{ width: '100%', height: '100%', display: 'block' }}><embed src={`data:application/pdf;base64,${base64data.data}`} width="100%" height="800px"
            type="application/pdf" /></div>
    )
}
